import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isSameMonth } from 'date-fns';
import { format } from 'date-fns';

import { SFIcon } from 'components/core/SFIcon';
import { Button } from 'components/core/Button';
import { Text } from 'components/core/Typography';

import './calendarHeader.scss';

export function CalendarHeader({
	onCloseClick,
	headerLabel,
	month,
	onNextClick,
	onPreviousClick,
	allValid,
	today
}) {
	const isPrevDisabled = !allValid && isSameMonth(today, month);

	const handlePrevClick = useCallback((evt) => {
		if (!isPrevDisabled) {
			onPreviousClick(evt);
		}
	}, [isPrevDisabled, onPreviousClick]);

	return (
		<div className="ph-calendar-header">
			<Button
				primary={false}
				className="ph-calendar-close"
				onClick={onCloseClick}
			>
				<SFIcon icon="close" />
			</Button>
			<div className="ph-calendar-controls">
				{headerLabel &&
					<div className="header-label">
						{headerLabel}
					</div>
				}
				<div className="header-month">
					<Button
						primary={false}
						disabled={isPrevDisabled}
						className={classnames({ disabled: isPrevDisabled })}
						onClick={handlePrevClick}
					>
						<SFIcon icon="chevron-left" />
					</Button>
					<Text
						className="month"
						size="medium"
					>
						{format(month, 'MMMM yyyy')}
					</Text>
					<Button
						primary={false}
						onClick={onNextClick}
					>
						<SFIcon icon="chevron-right" />
					</Button>
				</div>
			</div>
		</div>
	);
}

CalendarHeader.propTypes = {
	headerLabel: PropTypes.node,
	month: PropTypes.instanceOf(Date),
	onNextClick: PropTypes.func,
	onCloseClick: PropTypes.func,
	onPreviousClick: PropTypes.func,
	allValid: PropTypes.bool,
	today: PropTypes.instanceOf(Date),
};

export default CalendarHeader;
